import {convertToSlug} from "../../services/utils";
import './index.scss'

const Textarea = ({
                    label = "",
                    id = convertToSlug(label) || "customTextarea", name,
                    value = '', setValue,
                    onBlur, isDisabled = false, placeholder
                  }) => {
  return (
    <div className="custom-textarea">
      <div className="input-textarea">
        <label htmlFor={id} className="input-textarea-label">{label}</label>
        <textarea
          className="input-textarea-textarea"
          name={name}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onBlur={onBlur}
          disabled={isDisabled}
          placeholder={placeholder}
          id={id} />
      </div>
    </div>
  )
}

export default Textarea